import { getDaysSinceUserSignup } from 'mini-common-utils/lib/utils/getDaysSinceUserSignup';
import { getPushNotificationsOnboardingImpressionCount } from './getPushNotificationsOnboardingData';
import { isModuleEngagedUser } from 'mini-campaign-bootstrap/lib/utils/isModuleEngagedUser';
import { Modules } from 'mini-usercustomproperties';

export const getPushNotificationsSurfaceRealtimeSignals = async () => {
    const isEngagedMailUser = await isModuleEngagedUser(Modules.MAIL);
    const browserImpressionCount = await getPushNotificationsOnboardingImpressionCount();
    /**
     * daysSinceSignup is added to ensure that PushNotifications are not shown while OnboardingCards are shown.
     * Currently OnboardingCards are shown for 30 days. If that value changes, ensure to update corresponding value in IRIS for push notifications.
     */
    return (
        'ISENGAGEDUSER=' +
        isEngagedMailUser +
        '&BROWSERIMPRESSIONCOUNT=' +
        browserImpressionCount +
        '&DAYSSINCESIGNUP=' +
        getDaysSinceUserSignup()
    );
};
